import { render, staticRenderFns } from "./position-selector.vue?vue&type=template&id=35980c2a&"
import script from "./position-selector.vue?vue&type=script&lang=js&"
export * from "./position-selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports